import type { TeaPurchase } from '@/lib/api/tea-purchase-api'
import { ListCard } from '@/components/common/ListCard'
import { Badge } from '@/components/ui/badge'
import { formatDateVN, formatQty } from '@/lib/format'
import { m } from '@/lib/paraglide/messages'

/**
 * Danh sách phiếu cân chè TƯƠI cho tài khoản hộ trồng — CHỈ ĐỌC.
 *
 * Khác màn quản trị `/tea-purchases` ở chỗ không có nút tạo/sửa/duyệt/in/xuất
 * Excel và không hiện các cột nội bộ (người tạo, người duyệt, ghi chú, cờ trả
 * phiếu giấy). Dùng `ListCard` để trên điện thoại hộ đọc được không cần cuộn
 * ngang.
 */

/** Nhãn kiểu chè (Mầm/Xuân/Lứa). */
const PATTERN_LABEL: Record<string, () => string> = {
    mam: () => m.tea_purchase_pattern_mam(),
    xuan: () => m.tea_purchase_pattern_xuan(),
    lua: () => m.tea_purchase_pattern_lua(),
}

export function FreshWeighingList({ items }: { items: TeaPurchase[] }) {
    return (
        <div className="space-y-2">
            {items.map((row) => (
                <ListCard
                    key={row.id}
                    title={
                        <span className="font-mono text-sm font-semibold">
                            {row.code}
                        </span>
                    }
                    subtitle={row.grower_name || undefined}
                    badge={
                        row.approved_at ? (
                            <Badge variant="default">
                                {m.tea_purchase_status_approved()}
                            </Badge>
                        ) : (
                            <Badge variant="outline">
                                {m.tea_purchase_status_pending()}
                            </Badge>
                        )
                    }
                    metric={{
                        label: m.my_weighings_metric_fresh(),
                        value: `${formatQty(row.quantity)} kg`,
                    }}
                    fields={[
                        {
                            label: m.tea_purchase_purchase_date(),
                            value: formatDateVN(row.purchase_date),
                        },
                        {
                            label: m.tea_purchase_tea_type(),
                            value: row.tea_type_name || '—',
                        },
                        {
                            label: m.tea_purchase_pattern(),
                            value: row.tea_pattern
                                ? (PATTERN_LABEL[row.tea_pattern]?.() ??
                                  row.tea_pattern)
                                : '—',
                        },
                    ]}
                />
            ))}
        </div>
    )
}
